import * as React from 'react';

// components
import { InputPassword as InputPasswordBase } from '@shopee-user/input';

// types
import { InputPasswordProps } from '@shopee-user/input';
export const MAX_PASSWORD_LENGTH = 16;
function InputPassword(props: InputPasswordProps) {
  return <InputPasswordBase maxLength={MAX_PASSWORD_LENGTH} {...props} />;
}

export default InputPassword;
